export * from '@primeuix/themes/aura/autocomplete';
export { default } from '@primeuix/themes/aura/autocomplete';
